import { Palette } from '@common/theming/Palette';
import React from 'react';
import { AssetBlockProps } from '../../pages/AssetApp';
import { TextBlock } from '../TextBlock';
import ProfileAssetHeading from './ProfileAssetHeading';

const RiskMitigants: React.FC<AssetBlockProps> = ({ asset }) => {
  return (
    <div>
      <ProfileAssetHeading heading={asset.risksAndMitigants?.heading} />
      <div>
        {asset.risksAndMitigants?.items.map((item, riskIdx) => {
          return (
            <div key={`risk-${riskIdx}`}>
              <TextBlock style={{ marginTop: 16, textDecorationLine: 'underline' }}>{item.heading}</TextBlock>
              <TextBlock color={Palette.WHITE_70} style={{ marginTop: 12 }}>
                {item.riskDescription}
              </TextBlock>

              <div>
                <TextBlock color={Palette.WHITE_70} style={{ marginTop: 12, paddingLeft: 6 }}>
                  Mitigation:
                </TextBlock>
                <ul style={{ listStyleType: 'disc', paddingLeft: 24 }}>
                  {item.mitigations.map((mitigation, mitIdx) => {
                    return (
                      <li
                        key={`mitigation-${riskIdx}-${mitIdx}`}
                        style={{ color: Palette.WHITE_70, marginLeft: 10, marginTop: 12 }}>
                        <TextBlock color={Palette.WHITE_70}>{mitigation}</TextBlock>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default RiskMitigants;
